import React from "react";
import DualPagination from "../../../common/DualPagination";
import TableSkeleton from "../../../skeletons/TableSkeleton";
import {
  noDataPresent,
  reffPartner,
  tooltiptextId
} from "../../../../locales/en";
import { Tooltip } from "react-tooltip";
import PropTypes from "prop-types";
import { formatCurrency, formatDateWithDayjs } from "../../../../utils/utils";
import { CURRENCY_FORMAT } from "../../../../utils/constants/appConstants";
import Modalstyle from "./../../../modals/modal.module.scss";
import { INVOICE_SUMMARY_COLUMNS } from "./Columns";

const CURRENCY_COLUMNS = [
  "invoiceAmountPaid",
  "invoiceTotal",
  "invoiceAmountDue",
  "invoiceAmountCredited"
];

export const DATE_COLUMNS = [
  "invoiceDate",
  "invoiceDueDate",
  "invoiceFullyPaidDate"
];

const DebtorTable = (props) => {
  const {
    gotoPage,
    pageIndex,
    pageCount,
    pageOptions,
    setPageSize,
    pageSize,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    tableData,
    loading,
    headerRef,
    visibleColumnCount,
    rows,
    headerGroups,
    getTableProps,
    getTableBodyProps,
    prepareRow,
    columns,
    theadData
  } = props;
  return (
    <div className="col-md-12">
      <table
        className={`mt-2 mb-3 common-table bgless_table ${Modalstyle.debtorPaymentDetailsTable}`}
        {...getTableProps()}
      >
        <thead ref={headerRef}>
          <tr>
            <th colSpan={3}>{reffPartner?.monthlyReport?.total}</th>
            {INVOICE_SUMMARY_COLUMNS.map((col) => (
              <th key={col.key} colSpan={col.colSpan}>
                {CURRENCY_FORMAT}
                {formatCurrency(theadData?.[col.key])}
              </th>
            ))}
          </tr>
          {headerGroups.map((headerGroup) => {
            const { key, ...rest } = headerGroup.getHeaderGroupProps();
            return (
              <tr key={key} className="parentrow" {...rest}>
                {headerGroup.headers.map((column) => (
                  <th key={column.id} {...column.getHeaderProps()}>
                    <span>{column.render("Header")}</span>
                  </th>
                ))}
              </tr>
            );
          })}
        </thead>
        <tbody {...getTableBodyProps()}>
          {loading && <TableSkeleton rows={10} columns={visibleColumnCount} />}
          {!loading && rows?.length === 0 && (
            <tr>
              <td colSpan={columns?.length + 2} className="text-center">
                {noDataPresent}
              </td>
            </tr>
          )}
          {!loading &&
            rows?.length > 0 &&
            rows.map((row) => {
              prepareRow(row);
              return (
                <React.Fragment key={row.id}>
                  <tr className="parentrow" {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      const rawValue = cell.value;
                      let displayValue = rawValue;
                      if (DATE_COLUMNS.includes(cell.column.id) && rawValue) {
                        displayValue = formatDateWithDayjs(
                          rawValue,
                          "DD-MMM-YYYY"
                        );
                      }

                      if (CURRENCY_COLUMNS.includes(cell.column.id)) {
                        displayValue =
                          CURRENCY_FORMAT + formatCurrency(rawValue);
                      }
                      return (
                        <td
                          key={cell.getCellProps().key}
                          {...cell.getCellProps()}
                        >
                          {displayValue}
                        </td>
                      );
                    })}
                  </tr>
                </React.Fragment>
              );
            })}
        </tbody>
      </table>
      {tableData && tableData?.length > 0 && (
        <DualPagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageCount={pageCount}
          pageOptions={pageOptions}
          setPageSize={setPageSize}
          pageSize={pageSize}
          dataLength={tableData?.length}
        />
      )}
      <Tooltip id={tooltiptextId.monthlyKpiReportId} place="top" />
    </div>
  );
};

DebtorTable.propTypes = {
  gotoPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func,
  nextPage: PropTypes.func,
  canPreviousPage: PropTypes.bool,
  canNextPage: PropTypes.bool,

  pageIndex: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  pageOptions: PropTypes.array.isRequired,
  pageSize: PropTypes.number,
  setPageSize: PropTypes.func,

  tableData: PropTypes.array,
  theadData: PropTypes.object,
  loading: PropTypes.bool,

  headerRef: PropTypes.object,
  visibleColumnCount: PropTypes.number,

  rows: PropTypes.array.isRequired,
  headerGroups: PropTypes.array.isRequired,
  getTableProps: PropTypes.func.isRequired,
  getTableBodyProps: PropTypes.func.isRequired,
  prepareRow: PropTypes.func.isRequired,
  columns: PropTypes.array.isRequired
};

export default DebtorTable;
